import { USER_TYPE } from "../constants";

export const dashboardUrl = {
  [USER_TYPE.LEARNER]: "/my_dashboard",
  [USER_TYPE.MENTOR]: "/dashboard",
  [USER_TYPE.ADMIN]: "/admin/home",
};

export const apiPath = {
  REFRESH_TOKEN: "refresh-token",
};
